<div class="row p-1">
  <div class="col-12 pageTitle">
    <h2>&nbsp;&nbsp;&nbsp;Roles List</h2>
  </div>
</div>

<div class="field col-2 md:col-2 mb-2">
  <button
    pButton
    type="button"
    label="Create Role"
    pTooltipPosition="true"
    icon="pi pi-plus"
    class="ui-button-plain buttonWidth-10 GreyButton"
    (click)="createRoles()"
  ></button>
</div>

<!--<p-table [columns]="cols" [value]="roles?.data" selectionMode="single" dataKey="roleId"
         [(selection)]="selectedRole" [paginator]="true" [rows]="3">-->

<p-table
  *ngIf="roles"
  [(first)]="first"
  [resetPageOnSort]="false"
  lazy="true"
  (onLazyLoad)="nextPage($event)"
  [totalRecords]="roles?.totalRecords"
  [currentPageReportTemplate]="'{currentPage} of {totalPages}'"
  [columns]="cols"
  [alwaysShowPaginator]="false"
  [rows]="rows"
  [paginator]="true"
  [value]="roles?.data"
  selectionMode="single"
  [sortOrder]="1"
  sortField="roleId"
  dataKey="roleId"
  [(selection)]="selectedRole"
  [autoLayout]="true"
>
  <ng-template pTemplate="header" let-columns>
    <tr *ngIf="Showrecords == true">
      <th *ngFor="let col of columns" [pSortableColumn]="col.field">
        {{ col.header }}
        <p-sortIcon
          [field]="col.field"
          ariaLabel="Activate to sort"
          ariaLabelDesc="Activate to sort in descending order"
          ariaLabelAsc="Activate to sort in ascending order"
        ></p-sortIcon>
      </th>
      <th class="col-2" style="text-align: center !important">Actions</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-rowData let-columns="columns">
    <tr [pSelectableRow]="rowData">
      <td *ngFor="let col of columns">
        {{ rowData[col.field] }}
      </td>
      <!--<td>
                {{rowData['roleName']}}
            </td>
            <td>
                {{rowData['roleDescription']}}
            </td>-->

      <td style="text-align: center !important">
        <button
          pButton
          type="button"
          icon="pi pi-pencil"
          pTooltip="Edit"
          class="p-button-link"
          (click)="onEdit(rowData)"
        ></button>
        <button
          pButton
          type="button"
          icon="pi pi-trash"
          pTooltip="Delete"
          class="p-button-link ml-3"
          (click)="dropRole($event, rowData['roleId'])"
        ></button>
      </td>
    </tr>
  </ng-template>

  <ng-template pTemplate="emptymessage" let-columns="columns">
    <tr>
      <td colspan="12" class="Colspan-Bg">
        <div class="w-12 bg-white">
          <div class="" style="text-align: center">
            <img
              _ngcontent-ng-c683320295=""
              class="profile-image"
              style="border-radius: 50%; width: 10rem; padding-top: 1rem"
              src="assets/imagesNew/table_error.png"
            />
          </div>
          <hr style="margin-bottom: 0.5rem" />
          <div
            class=""
            style="text-align: center; font-size: larger; color: #1d428f"
          >
            <i>No records found</i>
          </div>
        </div>
      </td>
    </tr>
  </ng-template>
</p-table>
